export const CHECKOUT_URL = 'https://electrical-technology-instructor-atlas.impultienda.ar/checkout'

export const HERO_IMAGE =
  'https://sb.impultienda.ar/storage/v1/object/public/ebook-images/6d5da149-c745-4a53-bdb0-43e6ca2d13ac/product-uploads/mcp_3151252a-5255-420d-a47f-2b772507654a_1793890167714.png'

export const HERO_IMAGE_ALT =
  'Electrical Technology Instructor Atlas 6-in-1 box set in navy blue, electric yellow and white: 6 visual electrical systems and technical training volumes for electrical instructors, technical schools and training workshops'

export const VISUAL_IMAGE =
  'https://sb.impultienda.ar/storage/v1/object/public/ebook-images/6d5da149-c745-4a53-bdb0-43e6ca2d13ac/product-uploads/mcp_3151252a-5255-420d-a47f-2b772507654a_1793890195588.jpg'

export const VISUAL_IMAGE_ALT =
  'Electrical Technology Instructor Atlas: the 6-volume box set next to a tablet with the electrical teaching areas, 100% visual material for electrical instructors and technical schools, with immediate access'

export const PRIMARY_CTA = 'GET ELECTRICAL TECHNOLOGY INSTRUCTOR ATLAS NOW!'

export const PRICE_LABEL = '$27 USD'

export interface IncludedItem {
  label: string
  kind: 'included' | 'bonus' | 'extra'
}

export const packageIncludes: IncludedItem[] = [
  { kind: 'included', label: 'Volume 01 — Electrical Fundamentals, Circuit Theory & Electrical Safety' },
  { kind: 'included', label: 'Volume 02 — Residential Electrical Wiring, Installations & Circuit Protection' },
  { kind: 'included', label: 'Volume 03 — Commercial & Industrial Electrical Systems, Motors & Controls' },
  { kind: 'included', label: 'Volume 04 — Electrical Diagrams, Testing, Troubleshooting & Fault Diagnosis' },
  { kind: 'included', label: 'Volume 05 — Industrial Automation, PLCs, Variable Frequency Drives & Smart Electrical Systems' },
  { kind: 'included', label: 'Volume 06 — Electrical Instruction, Workshop Training & Practical Assessments' },
  { kind: 'bonus', label: 'Electrical Formulas, Ohm’s Law & Wiring Quick-Reference Charts' },
  { kind: 'bonus', label: 'Electrical Demonstration Lesson Scripts' },
  { kind: 'bonus', label: 'Circuit-Building Lab Projects & Wiring Exercise Workbook' },
  { kind: 'bonus', label: 'Electrical Symbols & Fault-Finding Flashcards' },
  { kind: 'bonus', label: 'Electrical Competency Checklists, Rubrics & Certificates' },
  { kind: 'extra', label: '100% Visual Training System' },
  { kind: 'extra', label: 'Immediate Digital Access' },
  { kind: 'extra', label: 'One-Time Payment' },
]
